import { processLaunchingShellsAgentListMetaInfo } from '@/column-header/statistics/processlaunchingshells-agents-meta'
import { processLaunchingShellsTopAgentListMetaInfo } from '@/column-header/statistics/processlaunchingshells-topagents-meta'
import { privilegedExecLinuxAgentListMetaInfo } from '@/column-header/statistics/privilegedexeclinux-agents-meta'
import { privilegedExecLinuxTopAgentListMetaInfo } from '@/column-header/statistics/privilegedexeclinux-topagents-meta'
import { loginFailuresLinuxAgentListMetaInfo } from '@/column-header/statistics/loginfailureslinux-agents-meta'
import { loginFailuresLinuxTopAgentListMetaInfo } from '@/column-header/statistics/loginfailureslinux-topagents-meta'
import { sensitiveFileAccessLinuxAgentListMetaInfo } from '@/column-header/statistics/sensitivefileaccesslinux-agents-meta'
import { sensitiveFileAccessLinuxTopAgentListMetaInfo } from '@/column-header/statistics/sensitivefileaccesslinux-topagents-meta'
import { externalConnectionsLinuxAgentListMetaInfo } from '@/column-header/statistics/externalconnectionslinux-agents-meta'
import { externalConnectionsLinuxTopAgentListMetaInfo } from '@/column-header/statistics/externalconnectionslinux-topagents-meta'

const header = {
  'process-launching-shells': {
    agents: processLaunchingShellsAgentListMetaInfo,
    topagents: processLaunchingShellsTopAgentListMetaInfo
  },
  'privileged-execution': {
    agents: privilegedExecLinuxAgentListMetaInfo,
    topagents: privilegedExecLinuxTopAgentListMetaInfo
  },
  'login-failures': {
    agents: loginFailuresLinuxAgentListMetaInfo,
    topagents: loginFailuresLinuxTopAgentListMetaInfo
  },
  'sensitive-file-access': {
    agents: sensitiveFileAccessLinuxAgentListMetaInfo,
    topagents: sensitiveFileAccessLinuxTopAgentListMetaInfo
  },
  'external/connects': {
    agents: externalConnectionsLinuxAgentListMetaInfo,
    topagents: externalConnectionsLinuxTopAgentListMetaInfo
  }
}

export { header }



// WEBPACK FOOTER //
// ./src/column-header/statistics/index.js